import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-quibbler-hp5-how-far-will-fudge-go",
  name: `The Quibbler\n'How Far Will Fudge Go To Gain Gringotts'`,
  nameFormatted: {
    primary: "The Quibbler",
    secondary: "'How Far Will Fudge Go To Gain Gringotts'",
  },
  origin: `Harry Potter and the Order of the Phoenix`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
